<template>
  <div>
    <PageHeader title="Products" />
    <ProductListMenu :selected-products="selectedProducts" />
    <ProductListContent class="mt-5" :products="products" @newSelectedRows="newSelectedRows" />
    <Pagination
      :currentPage="currentPage"
      :total-pages="totalPages"
      :total-count="totalCount"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ProductListContent from "@/views/products/list/content/ProductListContent.vue";
import ProductListMenu from "@/views/products/list/menu/ProductListMenu.vue";
import { PageHeader, Pagination } from "@estaly/ui";

export default {
  components: {
    PageHeader,
    ProductListContent,
    Pagination,
    ProductListMenu,
  },
  data: () => {
    return {
      selectedProducts: [],
    };
  },

  watch: {
    selectedStore(newValue) {
      if (newValue) this.fetchIndex({ page: 1 });
    },
  },
  computed: {
    ...mapState("products", ["products", "currentPage", "totalPages", "totalCount", "selectedStore"]),
  },

  methods: {
    ...mapActions("products", ["fetchIndex", "updateFilter", "updateSearch"]),
    ...mapActions("notifications", ["notify"]),

    async handleChangePage(page) {
      await this.fetchIndex({ page: page });
    },

    newSelectedRows(selectedProducts) {
      this.selectedProducts = selectedProducts;
    },
  },
};
</script>
